import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export const ADMINISTRATOR = 'Administrator';
export const FACULTY_ADMIN = 'Imovina admin članice';
export const UNIVERSITY_ADMIN = 'Imovina admin';
export const UNIVERSITY_SUPER_ADMIN = 'Imovina super admin';
export const FACULTY = 'Imovina - Korisnik fakultet';
export const UNIVERSITY = 'Imovina - Korisnik univerzitet';

export const fetchActiveRole = () => axios.get('/user/type');
export const fetchUserOrganizationalUnit = () => axios.get('/user/organizational-unit');



// WEBPACK FOOTER //
// ./src/views/Assets/util/roles.js